export default "__VITE_ASSET__BwCsusL$__"